export default function initMascotBlink() {
    const sockets = document.querySelectorAll('.onk-eye-socket');
    const pupils  = document.querySelectorAll('.onk-pupil-rect');
    if (!sockets.length) return;

    const eyes = Array.from(sockets).map((socket, i) => ({
        socket,
        pupil: pupils[i] || null,
    }));

    function animateBlink() {
        const DURATION = 420;
        const start = performance.now();

        function frame(now) {
            const t = Math.min((now - start) / DURATION, 1);

            let scale;
            if      (t < 0.35) scale = 1 - easeIn(t / 0.35);
            else if (t < 0.55) scale = 0;
            else               scale = easeOut((t - 0.55) / 0.45);

            eyes.forEach(({ socket, pupil }) => {
                socket.style.transform = `scaleY(${scale})`;
                if (pupil) pupil.style.opacity = scale < 0.15 ? '0' : '1';
            });

            if (t < 1) {
                requestAnimationFrame(frame);
            } else {
                eyes.forEach(({ socket, pupil }) => {
                    socket.style.transform = '';
                    if (pupil) pupil.style.opacity = '1';
                });
                scheduleNext();
            }
        }

        requestAnimationFrame(frame);
    }

    function easeIn(t)  { return t * t; }
    function easeOut(t) { return 1 - (1 - t) * (1 - t); }

    function scheduleNext() {
        setTimeout(animateBlink, 2500 + Math.random() * 3500);
    }

    setTimeout(animateBlink, 1500 + Math.random() * 2000);
}
